import React, { useEffect, useState } from "react";
import backBtn from "../../assets/images/backBtn.svg";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import { useNavigate } from "react-router-dom";
import breadcrumb from "../../assets/images/breadcrumb.svg";
import { Breadcrumb, Modal, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useCommonMessage } from "../../common/CommonMessage";
import {
  updateUserProfileAction,
  updateUserProfileHandler,
} from "../../redux/action/updateUserProfile";
import Loader from "../Loder/loader";
import { STATUS_CODE } from "../../common";
import { getUserProfileHandler } from "../../redux/action/getUserProfile";
import { getItem, setItem } from "../../common/localStorage";

const ManageNotification = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const messageApi = useCommonMessage();

  const loginResponse = JSON.parse(getItem("loginResponse"));
  const getUserProfileSelector = useSelector((state)=>state?.getUserProfileData)
  const updateUserProfileSelector = useSelector(
    (state) => state?.updateUserProfile
  );

  const [preferences, setPreferences] = useState(
    loginResponse.userPreferenceConfig
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingChange, setPendingChange] = useState(null);

  const handleSwitchChange = (key, checked) => {
    if (!checked) {
      setPendingChange({ key, checked });
      setIsModalOpen(true);
    } else {
      const updatedPreferences = { ...preferences, [key]: checked };
      setPreferences(updatedPreferences);
      const payload = {
        id: loginResponse?.id,
        userPreferenceConfig: updatedPreferences,
      };

      dispatch(updateUserProfileHandler(payload));
    }
  };

  useEffect(() => {
    const userConfig = getUserProfileSelector?.data?.data?.userPreferenceConfig ?? {};
    setPreferences(userConfig);
  }, [getUserProfileSelector])

  const handleConfirmChange = () => {
    if (pendingChange) {
      const updatedPreferences = {
        ...preferences,
        [pendingChange.key]: pendingChange.checked,
      };

      setPreferences(updatedPreferences); 
      setPendingChange(null);
      setIsModalOpen(false);

      const payload = {
        id: loginResponse?.id,
        userPreferenceConfig: {
          sms: updatedPreferences.sms,
          push: updatedPreferences.push,
          email: updatedPreferences.email,
        },
      };
      dispatch(updateUserProfileHandler(payload));
    }
  };

  const handleCancelChange = () => {
    setPendingChange(null);
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (updateUserProfileSelector?.data?.statusCode === STATUS_CODE.OK) {
      messageApi.open({
        type: "success",
        content: updateUserProfileSelector?.data?.message,
      });
      setItem(
        "loginResponse",
        JSON.stringify(updateUserProfileSelector?.data?.data)
      );
      dispatch(updateUserProfileAction.updateUserProfileInfoReset());
    } else if (
      updateUserProfileSelector?.data?.statusCode === STATUS_CODE.BAD_REQUEST ||
      updateUserProfileSelector?.data?.statusCode === STATUS_CODE.NOT_FOUND ||
      updateUserProfileSelector?.data?.statusCode ===
        STATUS_CODE.SERVER_ERROR ||
      updateUserProfileSelector?.data?.statusCode === STATUS_CODE.UNAUTHORIZED
    ) {
      messageApi.open({
        type: "error",
        content: updateUserProfileSelector?.data?.message,
      });
      dispatch(updateUserProfileAction.updateUserProfileInfoReset());
    }
  }, [updateUserProfileSelector]);

  useEffect(() => {
    dispatch(getUserProfileHandler());
  }, []);

  return (
    <>
      {updateUserProfileSelector?.isLoading && (
        <Loader loaderTransForm="loaderTransForm" />
      )}
      <div className="py-50 mobileMargin">
        <div className="container">
          {[
            {
              key: "push",
              label: "Notifications",
              message: "Important updates sent to your inbox.",
            },
            {
              key: "email",
              label: "Email",
              message: "Instant updates on your device screen.",
            },
            {
              key: "sms",
              label: "SMS Notifications",
              message: "Urgent info via text messages.",
            },
          ].map((notification) => (
            <div key={notification.key} className="notificationCard">
              <div className="d-flex align-center justify-between gap-10 emailBorder">
                <div className="gb fw-600">{t(notification.label)}</div>
                <Switch
                  checked={preferences[notification.key]}
                  onChange={(checked) =>
                    handleSwitchChange(notification.key, checked)
                  }
                />
              </div>
              <div>{t(notification?.message)}</div>
            </div>
          ))}

          <Modal
            className="custom-modal responsiveModal text-center"
            open={isModalOpen}
            onCancel={handleCancelChange}
            footer={null}
            closeIcon={null}
            centered
            maskClosable={false}
          >
            <div className="gb fs-20 mb-12 text-center">
              {t("Manage Notifications")}
            </div>
            <div className="lh-25 mb-40 text-center">
              {t("Are you sure you want to turn off the notification?")}
            </div>
            <div className="yesNoOption">
              <button className="noBtn" onClick={handleCancelChange}>
                {t("Cancel")}
              </button>
              <button className="yesBtn" onClick={handleConfirmChange}>
                {t("Yes")}
              </button>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default ManageNotification;
